// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {LayoutColumn, LayoutWrapper} from 'components/Layout';
import {LocalizedParagraph, useLocalized, type LocalizedText} from 'components/Localized';
import Logo from 'components/Logo'
import {useSessionDispatch} from 'components/Session';
import * as d3 from 'd3';
import {getImageLevel} from 'components/Image'
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';
import ButtonNextPage from 'components/ButtonNextPage';
import {useLayoutState} from 'components/Layout';
//import d3ForceSurface from 'd3-force-surface';

type TypeData = {
  name?: string,
  radius: number,
  type?: string,
  image?: string,
  label?: LocalizedText,
  big?: boolean,
  x?: number,
  y?: number,
}

type Props = {
  nextPath: string,
};

export default function Survey(props: Props): React.Element<any> {
  const history = useHistory();
  const sessionDispatch = useSessionDispatch();
  const localized = useLocalized();
  const selected = React.useRef([]);
  const layoutState = useLayoutState();
  const [enableNext, setEnableNext] = React.useState(false);

  //React.useMemo<Array<LocalizedText>>(() => {
  const dataSrc: Array<TypeData> = React.useMemo<Array<TypeData>>( ()=>{ return [
    {
      name: '4',
      radius: 1,
      type: 'b',
      image: 'b-1',
      label: localized.tutorial_p02_survey_003,
      tag:"Comfort & Safety",
      big: false,
    },
    {
      name: '1',
      radius: 1,
      type: 'a',
      image: 'a-1',
      label: localized.tutorial_p02_survey_005,
      tag:"Speed & Power",
      big: false,
    },
    {
      name: '2',
      radius: 1,
      type: 'a',
      image: 'a-2',
      label: localized.tutorial_p02_survey_007,
      tag:"Private Time",
      big: false,
    },
    {
      name: '5',
      radius: 1,
      type: 'b',
      image: 'b-2',
      label: localized.tutorial_p02_survey_004,
      tag:"Family & Friends Time",
      big: false,
    },
    {
      name: '6',
      radius: 1,
      type: 'b',
      image: 'b-3',
      label: localized.tutorial_p02_survey_006,
      tag:"Scenic Driver",
      big: false,
    },
    {
      name: '3',
      radius: 1,
      type: 'a',
      image: 'a-3',
      label: localized.tutorial_p02_survey_008,
      tag:"Innovative & Tech-savvy",
      big: false,
    },

  ]}, [localized]);

  React.useEffect(()=>{
    AudioUtils.playBGM_UI();
    return ()=>{
    };
  }, []);
  React.useEffect(()=>{
    window.tagManager.surveyPage();
  },[]);

  const handleSelect = React.useCallback((index: number, checked: boolean) => {
    //handleSelect(0);
    if (selected.current.length < 3 || !checked) {
      let selectedList = selected.current.slice();
      const found = selectedList.indexOf(index);
      if (found >= 0) {
        selectedList.splice(found, 1);
      } else {
        selectedList.push(index);
        window.tagManager.driveTypeSurveySingleLinkClick(dataSrc[index].tag);
      }
      selected.current = selectedList;
      setEnableNext(selected.current.length > 0);
      return selectedList.includes(index);
    }
    setEnableNext(selected.current.length > 0);
    return false;
  }, [dataSrc]);

  const handleNext = React.useCallback(() => {
    //const typeList = ['b', 'a', 'a', 'b', 'b', 'a'];
    let countA = 0, countB = 0;
    let driveTypeName = "";
    let driveTypeNameArr = [];
    for (let i = 0; i < selected.current.length && i < 3; ++i) {
      if (dataSrc[selected.current[i]].type === 'a') {
        countA += 1;
      }
      else {
        countB += 1;
      }
      if (driveTypeName !== "") {
        driveTypeName += "-";
      }
      driveTypeNameArr.push(dataSrc[selected.current[i]].tag);
      driveTypeName += dataSrc[selected.current[i]].tag;
    }

    console.log("aa:driveTypeName=", driveTypeName, driveTypeNameArr);
    window.tagManager.driveTypeSurveyLinkClick(driveTypeNameArr);
    //console.log('survey', countA, countB, selected.current)
    if (countA > countB) {
      sessionDispatch({type: 'SELECT_CAR', data: 0});
      history.push(props.nextPath.replace(":cv", "cv-e-gt"));
    }
    else {
      sessionDispatch({type: 'SELECT_CAR', data: 1});
      history.push(props.nextPath.replace(":cv", "cv-gt-line"));
    }
  }, [sessionDispatch, history, props.nextPath, dataSrc]);

  const nodeRef = React.useRef(null);
  React.useEffect(() => {
    // const debugStrs = [
    //   "a1a1a1\na2a2a2\na3a3a3",
    //   "a1a1a1\na2a2a2",
    //   "a1a1a1\na2a2a2",
    //   "a1a1a1a2a2a2a3a3a3",
    //   "a1a1a1a2a2a2a3a3a3",
    //   "a1a1a1a2a2a2a3a3a3",
    // ];
    // for (var i = 0; i < debugStrs.length; ++i) {
    //   dataSrc[i].label.datatext = debugStrs[i];
    // }
   
    let nodes;
    let simulation;
    function create() {
      if (layoutState.mobile) {
        if (window.innerWidth < window.innerHeight) {
          //window.location.reload();
          return;
          
        } 
      }


      destroy();
      const container = nodeRef.current;
      if (!container) {
        //console.log("survey:created-skipped");
        return;
      }
      //const left = container.offsetLeft;
      //const top = container.offsetTop;

      const width = container.offsetWidth;
      const height = container.offsetHeight;
      // const marginX = width * 0.05;
      // const marginY = height * 0.05;
      //console.log("container:", container, top);
      let data: Array<TypeData> = [];
      data.push.apply(data, dataSrc);

      
      
      function checkVisibility(d) {
        //return "";
        if (d.fx != null || d.image == null) {
          return "hidden";
        }

        return "";
      }

      const radiusScale0 = d3
        .scaleSqrt()
        .domain([1, 2])
        .range([(height / 7) * 2.0, (height / 5) * 2.0]);


      const sizeRate = Math.sqrt(Math.pow(radiusScale0(1), 2) * Math.PI * dataSrc.length / (width * height));

      const radiusScale = function(d, extra) {
        return radiusScale0(d, extra) / sizeRate * 0.5;
      };

      //console.log("sizeRate:sizeRate=", sizeRate);
      const radius1 = radiusScale(1);

      const xScale = d3.scaleLinear().domain([0, dataSrc.length]).range([-radius1 * dataSrc.length, radius1 * dataSrc.length]);

      for (var i = 0; i < data.length; ++i) {
        let angle = Math.random() * Math.PI * 2.0;
        data[i].x = width * 0.5 + width * 0.25 * Math.cos(angle);
        data[i].y = height * 0.5 + height * 0.25 * Math.sin(angle);
      }


      const wallRadius = 0.25;
      const wallSize = 2.0 * radiusScale(wallRadius);
      /*
      // for (var x = wallSize; x < width ; x += wallSize * 2) {
      //   data.push({fx : x, fy : 0 , radius : wallRadius  });
      //   data.push({fx : x, fy : height  , radius : wallRadius  });
      // }
      // for (var y = wallSize; y < height ; y += wallSize * 2) {
      //   data.push({fx : 0, fy : y , radius : wallRadius  });
      //   data.push({fx : width, fy : y  , radius : wallRadius  });
      // }
      */

      for (let x = 0; x < 2 ; ++x) {
        data.push({fx : width * 0.5 + x * wallSize * 2 , fy : 0 , radius : wallRadius  });
        data.push({fx : width * 0.5 + x * wallSize * 2 , fy : height , radius : wallRadius  });
      }
      for (let x = 1; x < 2 ; ++x) {
        data.push({fx : width * 0.5 - x * wallSize * 2 , fy : 0 , radius : wallRadius  });
        data.push({fx : width * 0.5 - x * wallSize * 2 , fy : height , radius : wallRadius  });
      }


       data.push({fx : 0, fy : height * 0.5 , radius : wallRadius  });
       data.push({fx : width, fy : height * 0.5 , radius : wallRadius  });
      // data.push({fx : width * 0.5, fy : 0 , radius : wallRadius  });
      // data.push({fx : width * 0.5, fy : height, radius : wallRadius  });

      const margins = ["0.5em", "-0.5em", "-1.25em"];
      //const yScale = d3.scaleLinear().domain([0, data.length]).range([-height, height]);
      var img_scale = 1;
      if (getImageLevel() >= 2.0) {
        img_scale = 2;
      }

      var img_postfix = img_scale === 1 ? '' : '@2x';

      const svg = d3
        .select(nodeRef.current)
        .append('svg')
        .attr('class', 'bubbles')
        .attr('style', 'overflow:visible')
        .attr('id', 'bubbles')
        .attr('width', width)
        .attr('height', height)
        .append('g');
      //console.log(localized);



      function ticked() {
        if (simulation == null) {
          //console.log("survey:ticked, no simulation skipped");
          return;
        }


        nodes = svg.selectAll('g').data(data);

        

        //console.log("nodes.length, nodes:", nodes.length, nodes);
        const circles = nodes.enter().append('g');
        circles
          .append('circle')
          .attr("visibility", checkVisibility )
          .attr('r', (d) => radiusScale(d.radius) )
          .attr('data-name', (d) => d.name)
          .attr('fill', "rgba(0,0,0,0)");

        circles
          .append('svg:image')
          .attr("visibility", checkVisibility )
          .attr('x', (d) => -radiusScale(d.radius))
          .attr('y', (d) => -radiusScale(d.radius))
          .attr('width', (d) => radiusScale(d.radius) * 2.0)
          .attr('height', (d) => radiusScale(d.radius) * 2.0)
          .attr('pointer-events', 'none')
          .attr(
            'xlink:href',
            (d) =>
              d.image != null ?
              ((process.env.PUBLIC_URL ?? '') +
              '/ui/images/img-survey-small-' +
              d.image +
              img_postfix +
              '.png') : null
          );

        //var lines = d.label.datatext.split("\n");
//(d.big ? Math.min(d.label.datasize, radiusScale(d.radius) * 0.2 * 13/11) : Math.min(d.label.datasize, radiusScale(d.radius) * 0.2) ) + 'px')
        circles
          .append('svg:text')
          .attr("visibility", checkVisibility )
          .attr('y', 0)
          .attr('x', 0)
          .append('svg:tspan')
          .attr('x', 0)
          .attr("dy", (d)=>{var lines = (d.label?d.label.datatext : "").split("\n");return margins[lines.length - 1]; } )
          .attr('text-anchor', 'middle')
          .text((d) => { var lines = (d.label?d.label.datatext : "").split("\n"); return lines[0]; } )
          .attr('data-name', (d) => d.name)
          .attr('font-family', (d) => (d.label?d.label.datafont : "" ))
          .attr('font-size', (d) => Math.min(d.label?d.label.datasize : 0 , radiusScale(d.radius) * 0.2) * (d.big?13/11:1) + 'px')
          .attr('pointer-events', 'none')
          //.style('fill', (d) => (d.label?d.label.datacolor : "#000" ) )
          .style('fill', "#fff" )
          
          .append('svg:tspan')
          .attr("visibility", checkVisibility )
          .attr('x', 0)
          .attr("dy", "1.25em")
          .attr('text-anchor', 'middle')
          .text((d) => { var lines = (d.label?d.label.datatext : "").split("\n"); return lines[1]; } )
          .attr('data-name', (d) => d.name)
          .attr('font-family', (d) => (d.label?d.label.datafont : "" ))
          .attr('font-size', (d) => Math.min(d.label?d.label.datasize:0, radiusScale(d.radius) * 0.2)* (d.big?13/11:1) + 'px')
          .attr('pointer-events', 'none')
          //.style('fill', (d) => (d.label?d.label.datacolor : "#000" ))
          .style('fill', "#fff")

          .append('svg:tspan')
          .attr("visibility", checkVisibility )
          .attr('x', 0)
          .attr("dy", "1.25em")
          .attr('text-anchor', 'middle')
          .text((d) => { var lines = (d.label?d.label.datatext : "").split("\n"); return lines[2]; } )
          .attr('data-name', (d) => d.name)
          .attr('font-family', (d) => (d.label?d.label.datafont : "" ))
          .attr('font-size', (d) => Math.min(d.label?d.label.datasize:0, radiusScale(d.radius) * 0.2)* (d.big?13/11:1) + 'px')
          .attr('pointer-events', 'none')
          //.style('fill', (d) => (d.label?d.label.datacolor : "#000" ))
          .style('fill', "#fff")
        ;

        


        circles.merge(nodes).attr('transform', (d) => `translate(${d.x}, ${d.y})`);
        //simulation.tick(5);
      }


      simulation = d3
        .forceSimulation(data)
        .alphaDecay(1 - Math.pow(0.001, 1 / 900))
        //.alphaDecay(0)
        //.force('limit', wallForce)
        .on('tick', ticked);
      function applyForce() {
        //const left = container.offsetLeft;
        //const top = container.offsetTop;

        const width = container.offsetWidth,
          height = container.offsetHeight;
          //console.log("left, top, width, height:", left, top, width, height);

        simulation?.force('center', d3.forceCenter(width / 2, height / 2).strength( 1.20 ))
          .force(
            'x',
            d3.forceX((d) => width / 2 + 0.7 * xScale(d.index)).strength(0.0025)
          )
          .force(
            'y',
            d3.forceY((d) => height / 2 ).strength(0.01)
          )
          .force(
            'collision',
            d3
              .forceCollide()
              .radius((d) => radiusScale(d.radius) * 1.15)
              //.iterations(10)
              .strength(0.125)
          );
          // .force(
          //   'container',
          //   d3ForceSurface()
          //     .surfaces([
          //       {from: {x: left, y: top},                  to: {x: left, y: top + height}},
          //       {from: {x: left, y: top + height},         to: {x: left + width, y: top + height}},
          //       {from: {x: left + width, y: top + height}, to: {x: left + width, y: top}},
          //       {from: {x: left + width, y: top},          to: {x: left, y: top}},
          //       {to: {x: left, y: top + height},         from: {x: left + width, y: top + height}},
          //     ])
          //     .oneWay(true)
          //     .radius(60.0)
          //     .elasticity(1.0)
          // );
      }
      applyForce();
      //console.log('survey:created left,top,width,height:', left, top, width, height);

      function clickHandler(e: Event) {
        const el = e.target;
        if (!(el instanceof Element)) {
          return;
        }
        const nodeName = el.nodeName;
        if (nodeName === 'circle') {
          const name = el.getAttribute('data-name');
          const index = data.findIndex((d) => d.name === name);
          if (data[index].image == null) {
            return;
          }
          if (!data[index].big) {
            var bigcount = data.reduce((e, d) => (d.big ? e + 1 : e), 0);
            //console.log("bigcount:", bigcount);
            if (bigcount >= 3) {
              return;
            }
          }

          data[index].big = !data[index].big;
          handleSelect(index, data[index].big);
          data[index].radius = data[index].big ? 2 : 1;

          nodes = svg
            .selectAll('g')
            .data(data)
            .select('circle')
            .attr('fill', "rgba(0,0,0,0)")
            .attr('r', (d) => radiusScale(d.radius));

          nodes = svg
            .selectAll('g')
            .data(data)
            .transition()
            .duration(200)
            .select('image')
            .attr('x', (d) => -radiusScale(d.radius))
            .attr('y', (d) => -radiusScale(d.radius))
            .attr('width', (d) => radiusScale(d.radius) * 2.0)
            .attr('height', (d) => radiusScale(d.radius) * 2.0)
            .attr('pointer-events', 'none')
            .attr(
              'xlink:href',
              (d) =>
                d.image ?
                ((d.big ? 'ui/images/img-survey-big-' : 'ui/images/img-survey-small-') +
                d.image +
                img_postfix +
                '.png') : null
            );

            svg
            .selectAll('tspan')
            .attr('font-size', (d) => Math.min(d.label ? d.label.datasize : 0, radiusScale(d.radius) * 0.2) * (d.big?13/11:1) + 'px')

            ;

          //simulation.nodes(data).restart();
          simulation?.nodes(data).alpha(1).restart();
          simulation?.tick(30);

          setTimeout(() => {
            //applyForce();
          }, 100);
        }
      }

      document.getElementById('bubbles')?.addEventListener('click', clickHandler);
    }
    function destroy() {
      //d3.off("tick", ticked);
      d3.selectAll("svg > *").remove();
      //console.log("survey:destroyed");
      d3.selectAll('.bubbles > *').remove();
      var d = document.getElementById('bubbles');
      if (d != null) {
        d.remove();
      }
      simulation = null;
    }
    function resize() {
      //console.log('survey:window resize');
      if (layoutState.mobile) {
        if (window.innerWidth < window.innerHeight) {
          //window.location.reload();
          // return;
          destroy();
        } else {
          create();
        }
        return;
      }
      destroy();
      setTimeout(function () {
        create();
        setTimeout(function () {
          // if (simulation != null) {
          //   simulation.alpha(1).restart();
          //   simulation.tick(300);
          // }
        }, 1000);
      }, 100);
      //
    }

    window.addEventListener('resize', resize);

    create();
    return function () {
      window.removeEventListener('resize', resize);
      destroy();
    };
  }, [nodeRef, handleSelect, localized, layoutState.mobile, dataSrc]);

  return (
    <main>
      <Back />
        <Wrapper>
          <DivTitle>
            <LocalizedParagraph {...localized.tutorial_p02_survey_001} />
            <LocalizedParagraph {...localized.tutorial_p02_survey_002} />
          </DivTitle>
          <DivSelect></DivSelect>
          <DivMargin></DivMargin>
        </Wrapper>
        <UnscaledWrapper>
          <DivMargin></DivMargin>
          <DivSelect>
            <div id="d3parent" ref={nodeRef}></div>
          </DivSelect>

          <DivMargin></DivMargin>

        </UnscaledWrapper>
        <ButtonNextPage
          title={localized.tutorial_p02_survey_009}
          disabled={!enableNext}
          onNext={handleNext}
          widthM={129}
          widthD={205}
        />
      <Logo />
      <SoundToggleButton />
      <Disclaimer textKey="disclaimer_default" />
    </main>
  );
}

const UnscaledWrapper = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  justify-content: center;
  align-items: center;
`;


const Wrapper = styled(LayoutColumn)`
  width: 100%;
  height: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 0px;

  justify-content: center;
  align-items: center;
`;

const Back = styled(LayoutWrapper)`
  background-color: #05141f;
`;

const DivTitle = styled.div`
  flex: ${(props) => props.dataflex ?? 1};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 10;
  flex : 1;
`;

const DivSelect = styled.div`
  
  width: 100%;
  margin: 0 ${(props) => (props.theme.layout.mobile ? 30 : 113)}px;

  transform-origin: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex : 2;
  height : auto;

  > div {
    width: 100%;
    height: 100%;
    position: relative;
  }

`;

const DivMargin = styled.div`
  
  width: 100%;
  margin: 0 30 px;

  transform-origin: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex : 0.6;
  height : auto;

`;
